import SmallPllantBeingHeldByHandsImage from "../../images/tasks/small-plant-being-held-by-hands.jpeg";

import TransplantSmallTreeImage from "../../images/tasks/transplant-small-tree.jpeg";
import DividingLilliesOnABlueTarpImage from "../../images/tasks/dividing-lillies-on-a-blue-tarp.jpeg";

export const plantsCalendar = [{
    name: "Transplant established shrubs",
    description: "Transplanting is the process of moving a plant from one location to another. It is an important part of Local Bonsai. Transplanting is done for many reasons, including space constraints, design purposes, and simply the need to move a plant that is not thriving.",
    learn: "https://www.youtube.com/watch?v=1Yb2x3b3n6o",
    frequency: "Annual",
    bestMonths: ["June", "July"],
    otherMonths: ["August"],
    image: TransplantSmallTreeImage,
  },
  {
    name: "Dividing",
    description: "Dividing is the process of separating a plant into two or more parts. This is done to propagate new plants, or to control the size of an existing plant.",
    learn: "https://www.youtube.com/watch?v=1Yb2x3b3n6o",
    frequency: "Bi-annual",
    bestMonths: ["March", "April", "May", "August"],
    otherMonths: "none",
    image: DividingLilliesOnABlueTarpImage,
  },
  {
    name: "Planting",
    description: "Planting is the process of placing a plant into the ground. It is done to establish new plants, or to replace plants that have died.",
    learn: "https://www.youtube.com/watch?v=1Yb2x3b3n6o",
    frequency: "Bi-annual",
    bestMonths: ["April", "September"],
    otherMonths: ["March", "August"],
    image: SmallPllantBeingHeldByHandsImage,
  },
];